export class EmployeesDeptWiseCountDto {
    departmentId: number;
    count: number;
}